import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { IconName, ICONS_MAP, ICONS_NAME_MAP } from '@app/shared/components/icon/icons';
import { ICON_SIZE_MAP, IconSize } from '@app/shared/components/icon/icon-size';

const DEFAULT_STROKE_WIDTH = 1.75;

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIconComponent],
  viewProviders: [provideIcons(ICONS_MAP)],
})
export class IconComponent {
  public readonly name = input.required<IconName>();
  public readonly size = input.required<IconSize>();
  public readonly desktopSize = input<IconSize | null>(null);
  public readonly strokeWidth = input<number>(DEFAULT_STROKE_WIDTH);

  @HostBinding('class.tw-inline-flex') public hostClass = true;

  protected readonly desktopSizeWithFallback = computed(() => {
    return this.desktopSize() ?? this.size();
  });

  protected readonly ICONS_NAME_MAP = ICONS_NAME_MAP;
  protected readonly ICON_SIZE_MAP = ICON_SIZE_MAP;
}
